import { render, staticRenderFns } from "./CustomerContactTypeNew.vue?vue&type=template&id=7fbb7802&"
import script from "./CustomerContactTypeNew.vue?vue&type=script&lang=js&"
export * from "./CustomerContactTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports